import React from 'react';
import { Typography } from '@mui/material';
import Policy from './Policy';
import PolicyHeader from './PolicyHeader';
import CommonMapFunction from './CommonMapFunction';
import { helpData } from './AboutUsData';

function Help() {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {!isMobileParams && <PolicyHeader/>}
      <div className="aboutBackground">
      { !isMobileParams && <Typography className="headerText justifyCenter fw500 pt20 pb30">
          Help Documentation Questionnaires
        </Typography>}
        <Policy policyData={helpData} />
      </div>
    </div>
  );
}

export default Help;
